import { tw as i } from "../../../utils/tailwind.js";
const n = (s) => s % 2 === 0, f = (s) => s % 3 === 0, p = (s) => !n(s);
function t(s, o) {
  return s < o ? !1 : f(s - o);
}
function r({
  cardsCount: s,
  cardIndex: o
}) {
  let e = "", l = "";
  const c = i`flex`;
  return n(s) && (e = i`col-span-1`), !n(s) && o === 0 && (e = i`col-span-2`), f(s) ? l = i`md:col-span-2` : t(s, 5) ? o <= 1 ? l = i`md:col-span-3` : l = i`md:col-span-2` : t(s, 7) ? o <= 3 ? l = i`md:col-span-3` : l = i`md:col-span-2` : l = i`md:col-span-3`, [l, e, c];
}
function a() {
  return i`grid-cols-2 md:grid-cols-6`;
}
export {
  r as gridLayoutCardClass,
  a as gridLayoutListClass,
  f as isDivisibleBy3,
  n as isEven,
  p as isOdd,
  t as isThirdNumberAboveThreshold
};
